import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import formatFloatNum from '../../../../../../shared/utils/floatFormatter';

function SensorListItem({ sensor = {} }) {
  const { value, name, units } = sensor;
  const displayValue = typeof value === 'number' ? formatFloatNum(value, 2, 'ru-RU') : value || '–';

  return (
    <Box display="flex" justifyContent="space-between" py={0.5}>
      <Typography fontSize={14} color="text.secondary">
        {`${name}, (${units || ''})`}
      </Typography>
      <Typography fontSize={14} fontWeight={500}>
        {displayValue}
      </Typography>
    </Box>
  );
}

SensorListItem.propTypes = {
  sensor: PropTypes.shape({
    name: PropTypes.string.isRequired,
    units: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    sendTime: PropTypes.number,
  }).isRequired,
};

export default SensorListItem;
